import { SectionCompletionStatus } from "../constants";
import type {
  SectionCompletionCounts,
  SectionCompletionStatistics,
} from "../types";

export const getSectionCompletionCounts = (
  statistics: SectionCompletionStatistics,
): SectionCompletionCounts => ({
  answered:
    statistics.answeredRequiredQuestionsCount +
    statistics.answeredOptionalQuestionsCount,
  total: statistics.requiredQuestionsCount + statistics.optionalQuestionsCount,
});

export const getSectionCompletionStatus = ({
  answered,
  total,
}: SectionCompletionCounts): SectionCompletionStatus => {
  if (total === 0 || answered >= total) {
    return SectionCompletionStatus.COMPLETE;
  }

  if (answered === 0) {
    return SectionCompletionStatus.NONE;
  }

  return SectionCompletionStatus.PARTIAL;
};
